import { motion, useInView } from "framer-motion";
import { useRef } from "react";
interface AmountDisplayProps {
    value: string;
    explanation: string;
}
const AmountDisplay: React.FC<AmountDisplayProps> = ({ value, explanation }) => {
    const Ref = useRef(null);
    const InView = useInView(Ref, { once: false, amount: 0.2 });
    return (
        <motion.div
            ref={Ref}
            initial="hidden"
            animate={InView ? "visible" : "hidden"}
            variants={{
                hidden: { opacity: 0, y: 50 },
                visible: { opacity: 1, y: 0, transition: { duration: 4, type: "spring", bounce: 0.4 } },
            }}
            className="contain w-full flex flex-col text-center items-start justify-between gap-4">
            <div className="flex-1 font-normal text-[#F8D835] font-bungeeinline text-[36px] flex-wrap ">
                {value}
            </div>

            <div className="flex-1 font-normal text-black font-montserrat text-[22px] flex-wrap ">
                {explanation}
            </div>
        </motion.div>
    );
};
export default AmountDisplay;